/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : AircraftDetails.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : AircraftDetails main component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Jan 10,2022
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { useSelector } from "react-redux";

import { AircraftDetailsForm } from "./AircraftDetailsForm";
import { selectSelectedApmRecordLoader } from "stores/ApmWorkFlowStore";
import {
  selectAircraftDetailsMasterLoader,
  selectSaveDetailsLoader,
} from "stores/AircraftDetailsStore";
import { CommonLoader } from "components/CommonLoader";
import "./AircraftDetails.scss";

export const AircraftDetails: FC = () => {
  const currentApmFileRecordLoader = useSelector(selectSelectedApmRecordLoader);
  const saveDetailsLoader = useSelector(selectSaveDetailsLoader);
  const aircraftDetailsMasterLoader = useSelector(
    selectAircraftDetailsMasterLoader
  );
  return (
    <>
      {aircraftDetailsMasterLoader ||
      saveDetailsLoader ||
      currentApmFileRecordLoader ? (
        <CommonLoader />
      ) : (
        <AircraftDetailsForm />
      )}
    </>
  );
};
